import * as React from 'react'
import Countdown from '../../../../components/Countdown'
import styles from './index.module.scss'

interface IActCountdownProps {
  second: number // 倒计时秒数
  data?: any
  endTimeCallback?: Function
}

const FlashCountdown: React.FC<IActCountdownProps> = ({
  second,
  data,
  endTimeCallback
}) => {
  return (
    <Countdown
      targetTime={second}
      showDays
      className={styles['flash-time']}
      theme="card"
      textColor={data?.timeColor}
      textBgColor={data?.timeBgColor}
      endTimeCallback={endTimeCallback}></Countdown>
  )
}

export default FlashCountdown
